var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGiftTrust(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.25,
    fill: "white",
    stroke: "#DFDFDF",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12 25H28V27H12V25Z",
    fill: "#A65A23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25 18.8299L23.38 19.9999L20 15.3999L16.62 19.9999L15 18.8299L17.08 15.9999H12V21.9999H28V15.9999H22.92L25 18.8299Z",
    fill: "#A65A23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 14H25.82C25.93 13.69 26 13.35 26 13C26 11.34 24.66 10 23 10C21.95 10 21.04 10.54 20.5 11.35L20 12.02L19.5 11.34C18.96 10.54 18.05 10 17 10C15.34 10 14 11.34 14 13C14 13.35 14.07 13.69 14.18 14H12C10.89 14 10.01 14.89 10.01 16L10 27C10 28.11 10.89 29 12 29H28C29.11 29 30 28.11 30 27V16C30 14.89 29.11 14 28 14ZM23 12C23.55 12 24 12.45 24 13C24 13.55 23.55 14 23 14C22.45 14 22 13.55 22 13C22 12.45 22.45 12 23 12ZM18 13C18 12.45 17.55 12 17 12C16.45 12 16 12.45 16 13C16 13.55 16.45 14 17 14C17.55 14 18 13.55 18 13ZM12 27V25H28V27H12ZM12 16V22H28V16H22.92L25 18.83L23.38 20L20 15.4L16.62 20L15 18.83L17.08 16H12Z",
    fill: "#A65A23"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftTrust);
export default __webpack_public_path__ + "static/media/gift-trust.9355b66f755c9311c02e5f085ded5ff5.svg";
export { ForwardRef as ReactComponent };